import { mergeOptions } from '../../helpers/common/merge-options';
import { getParentWithClass } from '../../helpers/dom/get-parent-with-class';

export enum direction {
	"both",
	"vertical",
	"horizontal",
}

export interface DragScrollOptions {
	direction: direction,
	blurEdges: boolean,
	edgeSelector: string,
	offset: number,
}

// https://htmldom.dev/make-a-draggable-element/
export class DragScroll {
	private x = 0;
	private y = 0;
	private edge;

	private options: DragScrollOptions;
	static options: DragScrollOptions = {
		direction: direction.both,
		blurEdges: true,
		edgeSelector: 'js-tabs-edge',
		offset: 0
	};

	constructor(private element: HTMLElement, options?: DragScrollOptions) {
		this.options = mergeOptions(DragScroll, options, element);
		this.element.addEventListener('mousedown', this.mouseDownHandler);
		this.edge = getParentWithClass(this.element, this.options.edgeSelector);
		this.setBlurEdges();
	}

	mouseDownHandler = (e: MouseEvent) => {
		// Get the current mouse position
		this.x = e.clientX;
		this.y = e.clientY;

		document.addEventListener('mousemove', this.mouseMoveHandler);
		document.addEventListener('mouseup', this.mouseUpHandler);
	};

	mouseMoveHandler = (e: MouseEvent) => {
		// How far the mouse has been moved
		const dx = e.clientX - this.x;
		const dy = e.clientY - this.y;

		// scroll
		switch (this.options.direction) {
			case direction.horizontal:
				this.element.scrollLeft -= dx;
				break;
			case direction.vertical:
				this.element.scrollTop -= dy;
				break;
			case direction.both:
			default:
				this.element.scrollTop -= dy;
				this.element.scrollLeft -= dx;
				break;
		}

		// Reassign the position of mouse
		this.x = e.clientX;
		this.y = e.clientY;

		this.setBlurEdges();
	};

	mouseUpHandler = () => {
		document.removeEventListener('mousemove', this.mouseMoveHandler);
		document.removeEventListener('mouseup', this.mouseUpHandler);
	};

	setBlurEdges = () => {
		if (this.options.blurEdges) {
			const width = this.element.getBoundingClientRect().width;
			this.edge.classList.toggle('blur-right-off', this.element.scrollWidth - this.element.scrollLeft <= (width + this.options.offset))
			this.edge.classList.toggle('blur-left-off', this.element.scrollLeft <= this.options.offset)
		}
	}
}
